<template>
  <Page class="popup-editor" v-if="!isLoading">
    <div class="action">
      <div class="btn-container">
        <small
          class="text-danger mr-3"
          v-if="saveComponentState.error">
          {{saveComponentState.error}}
        </small>
        <small
          class="text-success font-weight-bold mr-3"
          v-if="saveComponentState.status === 'success'">
          <i class="fa fa-check" /> บันทึกแล้ว
        </small>
        <button
          type="button"
          class="btn btn-primary"
          @click="savePopupData">
          บันทึก
        </button>
        <Dropdown
          alignment="right">
          <template v-slot:dropdow-button>
            <button
              type="button"
              class="btn btn-outline-dark btn-action m-0 ml-2">
              <i class="fas fa-cog"></i>
            </button>
          </template>
          <div
            class="dropdown-item"
            @click.stop="changeTitle">
            เปลี่ยนชื่อป๊อบอัป
          </div>
        </Dropdown>
      </div>
    </div>
    <ChangeTitleModal
      v-if="showChangeTitleModal"
      :title.sync="popupData.name"
      :showChangeTitleModal.sync="showChangeTitleModal"/>
    <ManageOrderPopup
      :popupName.sync="popupData.name"
      :allItems.sync="popupData.data.allItems"
      :selectedIndex.sync="selectedIndex" />
    <ManagePopupMetaData
      v-if="popupData.data.allItems.length"
      :selectedIndex="selectedIndex"
      :allItems.sync="popupData.data.allItems"
      :item.sync="popupData.data.allItems[selectedIndex]" />
    <EmptyMessage
      v-if="!popupData.data.allItems.length">
      <h3>ไม่มีป๊อปอัพ</h3>
    </EmptyMessage>
  </Page>
</template>

<script>
import _ from 'lodash';
import { loadPopup, updatePopup } from '@/pageDesigner/api';
import Page from '@/layouts/Page.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import Dropdown from '@/components/Dropdown.vue';

import ChangeTitleModal from '../ChangeTitleModal.vue';
import BannerMixins from '../mixins';
import ManagePopupMetaData from './components/ManagePopupMetadata.vue';
import ManageOrderPopup from './components/ManageOrderPopup.vue';

export default {
  components: {
    ManagePopupMetaData,
    ManageOrderPopup,
    Page,
    EmptyMessage,
    ChangeTitleModal,
    Dropdown,
  },
  data() {
    return {
      selectedIndex: 0,
      showChangeTitleModal: false,
      popupData: null,
      defaultData: {
        name: '',
        data: {
          allItems: [],
        },
      },
      saveComponentState: {
        status: 'idle',
        error: '',
      },
      isLoading: false,
    };
  },
  mixins: [BannerMixins],
  created() {
    this.loadPopup();
  },
  methods: {
    async loadPopup() {
      this.isLoading = true;
      const response = await loadPopup();
      this.popupData = _.defaultsDeep(response.data, this.defaultData);
      if (this.popupData) {
        this.reSort();
      }
      this.isLoading = false;
    },
    reSort() {
      const showing = this.getPopupByStatus(this.popupData.data.allItems, 'showing');
      const pending = this.getPopupByStatus(this.popupData.data.allItems, 'pending');
      const ended = this.getPopupByStatus(this.popupData.data.allItems, 'ended');

      let allItems = [];
      allItems = [...showing, ...pending, ...ended];

      this.popupData.data = { ...this.popupData, allItems };
    },
    getPopupByStatus(allItems, status) {
      return _.chain(allItems)
        .filter((item) => {
          return this.getBannerStatus(item) === status;
        })
        .sortBy(['startPublish'])
        .value();
    },
    async savePopupData() {
      try {
        const response = await updatePopup(this.popupData);
        this.popupData = response.data;
        this.saveComponentState.status = 'success';
        this.saveComponentState.error = null;
      } catch (error) {
        this.saveComponentState.error = error.response.data;
        this.saveComponentState.status = 'error';
      }
    },
    changeTitle() {
      this.showChangeTitleModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-message-container {
  background: #FFF;
}

.action {
  position: absolute;
  right: 10px;
  top: 22px;
}
.popup-editor {
  width: calc(100vw - 260px);
  margin: auto;
  /* overflow: hidden; */
  /* min-height: 100vh;
  max-height: 100vh; */
}

.btn-container {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 991.98px) {
  .slider-editor {
    width: 100vw;
  }
}

@media screen and (max-width: 768px) {
  .popup-editor {
    width: 96vw;
    overflow-x: hidden;
    overflow-y: scroll;
    min-height: unset;
    max-height: unset;
  }
}
</style>
